import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loading from '../components/Loading';
import './ConectarInstagramPublic.css';

const ConectarInstagramPublic = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [influencerData, setInfluencerData] = useState(null);

  console.log('🎯 ConectarInstagramPublic renderizado. Token:', token);

  useEffect(() => {
    const validateToken = async () => {
      try {
        console.log('🔍 Validando token:', token);

        // Usar la URL completa del backend en lugar de URL relativa
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/content';
        const validationUrl = `${apiUrl}/public/validate-instagram-token/${token}/`;

        console.log('🌐 URL de validación:', validationUrl);

        const response = await axios.get(validationUrl);

        console.log('✅ Respuesta de validación:', response.data);

        if (response.data.success) {
          setInfluencerData(response.data);
        } else {
          setError(response.data.error);
        }
      } catch (err) {
        console.error('❌ Error al validar token:', err);
        console.error('❌ Response:', err.response);
        const errorMsg = err.response?.data?.error || 'Error al validar el link. Por favor, solicita uno nuevo.';
        setError(errorMsg);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      validateToken();
    } else {
      setError('Token no proporcionado en la URL');
      setLoading(false);
    }
  }, [token]);

  const handleConnectInstagram = () => {
    if (!influencerData) return;

    // Obtener el host base SIN /api/content
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    // Remover /api/content o /api si existe
    const backendUrl = apiUrl.replace(/\/api(\/content)?\/?$/, '');
    const connectUrl = `${backendUrl}/instagram/connect-influencer/${influencerData.influencer_id}/`;

    console.log('🔗 Redirigiendo a:', connectUrl);

    // Redirigir directamente (no popup en este caso, porque el influencer está en su propio navegador)
    window.location.href = connectUrl;
  };

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div className="public-connect-container">
        <div className="public-connect-card error-card">
          <div className="error-icon">❌</div>
          <h2>Link Inválido o Expirado</h2>
          <p className="error-message">{error}</p>
          <p className="error-help">
            Por favor, contacta al administrador para obtener un nuevo link de conexión.
          </p>
        </div>
      </div>
    );
  }

  // Si no hay datos del influencer todavía, no renderizar nada (loading o error ya se manejan arriba)
  if (!influencerData) {
    return null;
  }

  if (influencerData.instagram_connected) {
    return (
      <div className="public-connect-container">
        <div className="public-connect-card success-card">
          <div className="success-icon">✅</div>
          <h2>Cuenta Ya Conectada</h2>
          <div className="influencer-info">
            {influencerData.influencer_profile_image_url && influencerData.influencer_profile_image_url.trim() !== '' && (
              <img
                src={influencerData.influencer_profile_image_url}
                alt={influencerData.influencer_name || 'Influencer'}
                className="influencer-avatar-large"
              />
            )}
            <h3>{influencerData.influencer_name || 'Influencer'}</h3>
            <p className="instagram-username">@{influencerData.influencer_username || 'username'}</p>
          </div>
          <p className="success-message">
            Tu cuenta de Instagram <strong>@{influencerData.instagram_username || 'tu cuenta'}</strong> ya está conectada.
          </p>
          <p className="success-help">
            Puedes cerrar esta ventana. El administrador puede publicar contenido en tu cuenta de forma automática.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="public-connect-container">
      <div className="public-connect-card">
        {/* Header */}
        <div className="public-header">
          <div className="header-icon-large">📸</div>
          <h1>Conecta tu cuenta de Instagram</h1>
        </div>

        {/* Influencer Info */}
        <div className="influencer-info">
          {influencerData.influencer_profile_image_url && influencerData.influencer_profile_image_url.trim() !== '' && (
            <img
              src={influencerData.influencer_profile_image_url}
              alt={influencerData.influencer_name || 'Influencer'}
              className="influencer-avatar-large"
            />
          )}
          <h2>Hola, {influencerData.influencer_name || 'Influencer'}</h2>
          <p className="instagram-username">@{influencerData.influencer_username || 'username'}</p>
        </div>

        {/* Info Section */}
        <div className="info-section">
          <p className="info-text">
            Para poder publicar contenido en tu cuenta de Instagram de forma automática,
            necesitamos que autorices tu cuenta profesional.
          </p>

          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">🔒</span>
              <span className="feature-text">Seguro y privado</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span className="feature-text">Solo tú puedes autorizar</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔄</span>
              <span className="feature-text">Puedes revocar en cualquier momento</span>
            </div>
          </div>
        </div>

        {/* Connect Button */}
        <button
          onClick={handleConnectInstagram}
          className="btn-connect-instagram"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path fill="#fff" d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z M17.5 6.5h.01" />
          </svg>
          Conectar mi Instagram
        </button>

        {/* Requirements */}
        <div className="requirements-section">
          <h4>Requisitos:</h4>
          <ul className="requirements-list">
            <li>Cuenta de Instagram <strong>Business</strong> o <strong>Creator</strong></li>
            <li>Vinculada a una <strong>Página de Facebook</strong> que administres</li>
            <li>Debes ser administrador de la Página</li>
          </ul>
        </div>

        {/* Footer */}
        <div className="public-footer">
          <p className="footer-text">
            Al conectar tu cuenta, autorizas a la plataforma para publicar contenido
            previamente aprobado en tu cuenta de Instagram.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConectarInstagramPublic;
